module.exports = __webpack_public_path__ + "img/2sczt.02675799.png";